import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = { style: {"height":"40px"} }
const _hoisted_2 = { class: "d-flex justify-center mt-5" }
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = { class: "pr-2" }
const _hoisted_5 = { class: "d-flex justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "pr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        cols: "12",
        class: "my-3 justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "4",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              (_ctx.mode === 'displayOnly')
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    outlined: "",
                    items: _ctx.allAuditCheckTypes,
                    "item-title": "title",
                    "item-value": "value",
                    modelValue: _ctx.auditCheckType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.auditCheckType) = $event)),
                    "hide-details": "",
                    label: "Sélectionner un type de contrôle",
                    "full-width": false,
                    "item-density": "compact"
                  }, null, 8, ["items", "modelValue"]))
                : (_openBlock(), _createBlock(_component_v_select_filled, {
                    key: 1,
                    outlined: "",
                    items: _ctx.allAuditCheckTypes,
                    "item-title": "title",
                    "item-value": "value",
                    modelValue: _ctx.auditCheckType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.auditCheckType) = $event)),
                    "hide-details": "",
                    label: "Sélectionner un type de contrôle",
                    "full-width": false,
                    "item-density": "compact"
                  }, null, 8, ["items", "modelValue"]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "4",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              (_ctx.mode === 'displayOnly')
                ? (_openBlock(), _createBlock(_component_v_text_field, {
                    key: 0,
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                    label: "Recherche",
                    outlined: "",
                    "hide-details": "",
                    density: "compact",
                    clearable: "",
                    "onClick:clear": _ctx.onClearSearch,
                    "append-inner-icon": "$search"
                  }, null, 8, ["modelValue", "onClick:clear"]))
                : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                    key: 1,
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                    label: "Recherche",
                    outlined: "",
                    "hide-details": "",
                    density: "compact",
                    clearable: "",
                    "onClick:clear": _ctx.onClearSearch,
                    "append-inner-icon": "$search"
                  }, null, 8, ["modelValue", "onClick:clear"]))
            ]),
            _: 1
          }),
          (_ctx.mode === 'displayOnly')
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.items.length) + " contrôles", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            style: {"overflow-y":"auto","height":"calc(100vh - 260px)"},
            id: "auditChecks-list"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "8" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_list, {
                          lines: "three",
                          style: {"background":"transparent"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                class: "oss-list-item mb-1 pa-0",
                                key: item.key,
                                style: {"width":"40vw"},
                                onClick: ($event: any) => (_ctx.displayExistingAudit(item)),
                                disabled: _ctx.isAuditAlreadySelected(item.key),
                                "model-value": item
                              }, _createSlots({
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "2",
                                        class: "d-flex justify-center align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            icon: _ctx.auditCheckIcon(item.type),
                                            color: _ctx.auditCheckColor(item),
                                            size: "large",
                                            class: "ma-1"
                                          }, null, 8, ["icon", "color"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, { cols: "10" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, { class: "text-wrap" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.title), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_v_list_item_subtitle, {
                                            class: _normalizeClass(
                                                    _ctx.isAuditAlreadySelected(item.key)
                                                        ? 'text--secondary my-2 text-wrap'
                                                        : 'text--primary my-2 text-wrap'
                                                ),
                                            textContent: _toDisplayString(
                                                    _ctx.$t('audit.accessRight.' + item.accessRight) +
                                                    ' - ' +
                                                    _ctx.$t('audit.status.' + item.status)
                                                )
                                          }, null, 8, ["class", "textContent"]),
                                          (_ctx.isAuditAlreadySelected(item.key))
                                            ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                                key: 0,
                                                class: "text--primary my-2 text-wrap"
                                              }, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                  _createElementVNode("strong", null, " Ce contrôle est déjà présent dans ce dossier de révision ", -1)
                                                ])),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, [
                                (
                                            _ctx.mode === 'displayOrSelect' &&
                                            !_ctx.isAuditAlreadySelected(item.key)
                                        )
                                  ? {
                                      name: "append",
                                      fn: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_3, [
                                          _createElementVNode("div", _hoisted_4, [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                _createTextVNode(" $oss-chevron-right ")
                                              ])),
                                              _: 1
                                            })
                                          ])
                                        ])
                                      ]),
                                      key: "0"
                                    }
                                  : (_ctx.mode === 'enableActions')
                                    ? {
                                        name: "append",
                                        fn: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_5, [
                                            (_ctx.mode === 'enableActions')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                  (
                                                        item.type ===
                                                        'ACCOUNTING_REVIEW_MANUAL_CUSTOM'
                                                    )
                                                    ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                                        key: 0,
                                                        onClick: _withModifiers(($event: any) => {
                                                        _ctx.toggleDeleteAuditCheckDialog();
                                                        _ctx.selectItemToDelete(item.id);
                                                    }, ["stop"]),
                                                        disabled: 
                                                        item.accountingReviewLayouts.length > 0
                                                    ,
                                                        size: "small"
                                                      }, null, 8, ["onClick", "disabled"]))
                                                    : _createCommentVNode("", true),
                                                  _createVNode(_component_v_icon, null, {
                                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                      _createTextVNode(" $oss-chevron-right ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        key: "1"
                                      }
                                    : undefined
                              ]), 1032, ["onClick", "disabled", "model-value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.deleteAuditCheckDialog)
            ? (_openBlock(), _createBlock(_component_oss_dialog, {
                key: 0,
                modelValue: _ctx.deleteAuditCheckDialog,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.deleteAuditCheckDialog) = $event)),
                title: "Souhaitez-vous vraiment supprimer ce contrôle ?",
                validTitle: "Supprimer",
                error: true,
                onValid: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteAuditCheck(_ctx.itemToDelete))),
                onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetItemToDelete())),
                width: "1000px"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}